export default __webpack_public_path__ + "static/media/bg-7.6c76ea8f.png";